const OrderErrorMessage = ({ order }) => {
  if (order && order.orderRequest && order.orderRequest.error) {
    return <p class="text-error">{order.orderRequest.error.message}</p>;
  }
  return null;
};

export default OrderErrorMessage;



// WEBPACK FOOTER //
// ./routes/tickets/components/OrderErrorMessage.js